import React, { createContext, useState, useEffect } from "react"
import {useDispatch, useSelector} from "react-redux";
import { setFormField, setUserType } from '../store/reducers/registrationSlice';
import {endpoints} from "../servics/apiEndpoints";

const FormContext = createContext({})

export const FormProvider = ({ children }) => {

    const title = {
        0: 'company_signup_step_1',
        1: 'company_signup_step_2',
        2: 'company_signup_step_3',
        3: 'company_signup_step_4',
        4: 'company_signup_step_5'
    }

    const {
        userType,
    } = useSelector(state => state.userType);

    // 🔽 Get the full registration state
    const registration = useSelector(state => state.registration);

    const dispatch = useDispatch();
    const language_code = useSelector(state => state.lang);
    const iso2 = useSelector((s) => s.country.country?.label) || 'togo';
    const countryCode = iso2.toLowerCase();

    const [page, setPage] = useState(0)

    const [data, setData] = useState(registration.heroFormFields);

    useEffect(() => {
        const fetchGeoInfo = async () => {
            try {
                const res = await fetch(endpoints.geoInfo);
                const datas = await res.json();

                dispatch(setUserType('hero'))

                dispatch(setFormField({ field: 'gender', value: 'not defined' }));
                dispatch(setFormField({ field: 'isCompany', value: true }));
                dispatch(setFormField({ field: 'ipAddress', value: datas.ip || '' }));
                dispatch(setFormField({ field: 'residenceCountry', value: datas.country || '' }));
                dispatch(setFormField({ field: 'activityCountry', value: countryCode || '' }));
                dispatch(setFormField({ field: 'residenceCity', value: datas.city || '' }));
                dispatch(setFormField({ field: 'platformSource', value: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web' }));

            } catch (error) {
                console.error('❌ Erreur de géolocalisation IP :', error);
            }
        };

        fetchGeoInfo();
    }, []);

    useEffect(() => {
        // setData(heroFormFields.heroFormFields)
        setData(registration.heroFormFields);
        // Display console
        // console.log("The userType", userType);
        // console.log("The heroFormFields in store", registration.heroFormFields);
        // console.log("The heroFormFiels data", data);
    }, [registration.heroFormFields]);

    const [errors, setErrors] = useState({});

    const requiredFieldsByStep = {
        0: [
            "firstName",
            "lastName",
            "gender",
            "telephone",
            "email",
            "nationality",
            "nationalIdOrPassport"
        ],
        1: [
            "companyName",
            "companyCode",
            "companySector",
            "companyStatus",
            "companyAgroRealm",
            "responsabilityInCompany",
            "preferredLanguage",
            "deliveryAddress"
        ],
        2: [
            "isProducer",
            "isSpeculator",
            "isCooperative",
            "isTrader",
            "isTransformer",
            "isImporter",
            "isExporter",
            "importExportType",
        ],
        3: [

            "countriesOfOperation",
            "companyPhoneNumber",
            "companyEmail",
            "subscriptionPlan",
            "wishesWhenRegistering",
            "importExportProof",
            "powerOfAttorneyFile"
            // optInNews est optionnel
        ],
        4: [
            "optInAnnual",
        ]
    }

    const stepValidators = {
        0: () => requiredFieldsByStep[0].every(key => Boolean(data[key])),
        1: () => requiredFieldsByStep[1].every(key => Boolean(data[key])),
        2: () => {
            // Au moins une activité doit être cochée
            const atLeastOneActivity = [
                "isProducer",
                "isSpeculator",
                "isCooperative",
                "isTrader",
                "isTransformer",
                "isImporter",
                "isExporter"
            ].some(key => data[key] === true)

            return atLeastOneActivity && !!data.importExportType;
        },
        3: () => {
            // page 4 validator: check your textarea field
            return data.wishesWhenRegistering && data.wishesWhenRegistering.trim() !== '';
        },
        4: () => {
            // Step 4 (final step) validator
            // If the checkbox must be checked to proceed:
            //return data.optInAnnual === true;

            // OR, if the checkbox is optional, just always return true:
            return true;
        }
    }

    const validateStep = (page) => {
        // console.log("VALIDATE STEP RUNNING for page", page);
        const newErrors = {};

        if (page === 0 && !data.firstName) {
            newErrors.firstName = "First name is required";
        }

        setErrors(newErrors);
        // console.log("Errors set:", newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (eOrName, maybeValue) => {
        let name, value;

        if (typeof eOrName === "string") {
            // Cas: appelé directement avec (name, value) → ex. PhoneInput
            name = eOrName;
            value = maybeValue;
        } else {
            // Cas: event DOM classique
            ({ name, value } = eOrName.target);
        }

        let parsedValue;
        if (value === "true") parsedValue = true;
        else if (value === "false") parsedValue = false;
        else parsedValue = value;

        // Validation email
        if (name === "email" || name === "companyEmail") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setErrors(prev => ({
                ...prev,
                [name]: emailRegex.test(value) ? "" : "Invalid Email"
            }));
        }

        setData(prev => ({
            ...prev,
            [name]: parsedValue
        }));

        // Efface l’erreur pour ce champ
        setErrors(prev => ({ ...prev, [name]: "" }));
    };

    const isLastPage = page === Object.keys(title).length - 1;
    // const canSubmit = isLastPage && Object.keys(stepValidators).every(step => stepValidators[step]());
    const canSubmit = isLastPage && stepValidators[page]();

    const disablePrev = page === 0

    const disableNext = page === Object.keys(title).length - 1; // only disable on last page

    const handleNext = () => {
        if (validateStep(page)) {
            setPage(prev => prev + 1);
        } else {
            console.log("Step not valid, stay here");
        }
    };

    const prevHide = page === 0 && "remove-button"

    const nextHide = page === Object.keys(title).length - 1 && "remove-button"

    const submitHide = page !== Object.keys(title).length - 1 && "remove-button"

    // Files uploads
    const [importExportFiles, setImportExportFiles] = useState([]);
    const [powerOfAttorneyFiles, setPowerOfAttorneyFiles] = useState([]);

    const handleImportExportChange = (e) => {
        setImportExportFiles(Array.from(e.target.files));
    };

    const handlePowerOfAttorneyChange = (e) => {
        setPowerOfAttorneyFiles(Array.from(e.target.files));
    };

    const handleRemoveImportExportFile = (fileName) => {
        setImportExportFiles(prev => prev.filter(f => f.name !== fileName));
    };

    const handleRemovePowerOfAttorneyFile = (fileName) => {
        setPowerOfAttorneyFiles(prev => prev.filter(f => f.name !== fileName));
    };

    // console.log("isLastPage:", isLastPage);
    // console.log("validators:", Object.keys(stepValidators).map(step => ({
    //     step,
    //     result: stepValidators[step]()
    // })));

    return (
        <FormContext.Provider value={{ title, page, setPage, data, setData, errors, setErrors, canSubmit,
                                       handleChange, disablePrev, disableNext, handleNext, prevHide, nextHide,
                                       submitHide, validateStep, importExportFiles, powerOfAttorneyFiles,
            handleRemoveImportExportFile, handleRemovePowerOfAttorneyFile, handleImportExportChange, handlePowerOfAttorneyChange }}>
        {children}
        </FormContext.Provider>
    )
}

export default FormContext 